<template>
  <div @drop="up" @dragover="tuoZhuaiZhong($event)">
    <el-dialog class="wp95 hp90" :model-value="openTiaoKe" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">调课</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openTiaoKe', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="mb10" style="display: flex;justify-content: center;align-items: center;">
        <h1 v-if="kblx===1" style="text-align: center;">教师课表</h1>
        <h1 v-if="kblx===2" style="text-align: center;">班级课表</h1>
        <h1 class="ml10 mt4" style="margin-bottom: -5px;" v-if="jiaZai"><el-icon class="is-loading">
            <RefreshRight />
          </el-icon></h1>
      </div>
      <div class="tiaoke_ul" style="display: flex;">
        <div class="tiaoke_li" v-for="(rqItem, rqIndex) in rqTableData" :key="rqIndex">
          <el-container>
            <el-header style="height: 27px;">
              <h3 v-if="rqItem.zc">第{{ rqItem.zc }}周课表</h3>
            </el-header>
            <el-main class="mt10 pl10 pr0 pb0">
              <table border="1" style="border-collapse: collapse; width: 100%;">
                <thead>
                  <tr align="center">
                    <th style="width: 50px;">节次</th>
                    <th v-for="(rqVal, rqV) in rqItem.listRiQi" :key="rqV">
                      <div v-if="rqV===0">
                        <p>星期一</p>
                        <p>{{rqVal.slice(5)}}</p>
                      </div>
                      <div v-if="rqV===1">
                        <p>星期二</p>
                        <p>{{rqVal.slice(5)}}</p>
                      </div>
                      <div v-if="rqV===2">
                        <p>星期三</p>
                        <p>{{rqVal.slice(5)}}</p>
                      </div>
                      <div v-if="rqV===3">
                        <p>星期四</p>
                        <p>{{rqVal.slice(5)}}</p>
                      </div>
                      <div v-if="rqV===4">
                        <p>星期五</p>
                        <p>{{rqVal.slice(5)}}</p>
                      </div>
                      <div v-if="rqV===5">
                        <p>星期六</p>
                        <p>{{rqVal.slice(5)}}</p>
                      </div>
                      <div v-if="rqV===6">
                        <p>星期日</p>
                        <p>{{rqVal.slice(5)}}</p>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr align="center" v-if="!tableData[rqIndex]">
                    <td colspan="8">暂无数据</td>
                  </tr>
                  <tr v-for="(item, index) in tableData[rqIndex]" :key="index">
                    <td align="center">
                      <div style="width: 50px;">{{ item.jc }}</div>
                    </td>
                    <!-- [tkbz]调课标志: 0-正常，1-已调课 -->
                    <td align="center" v-for="(xqItem, xqIndex) in item.xqs" :key="xqIndex" allowdrop :draggable="xqItem.kcs.length > 0 && kblx===1" @dragstart="tuoZhuaiKaiShi($event, xqItem)" @dragover="tuoZhuaiZhong($event)" @drop="fangXia($event, xqItem)">
                      <div class="neirong" :class="xqItem.sfkt===true?'ketiao':xqItem.sfkt===false?'buketiao':''" :style="kblx===2?'cursor: default;':xqItem.kcs.length?'cursor: move;':'cursor:not-allowed'">
                        <div v-for="(kcItem, kcIndex) in xqItem.kcs" :key="kcIndex">
                          <el-popover v-if="xqItem.isJskb && kcItem.tkbz === 1" placement="right">
                            <template #reference>
                              <div class="neirong" :class="xqItem.sfkt===true?'ketiao':xqItem.sfkt===false?'buketiao':''" :style="kblx===2?'cursor: default;':xqItem.kcs.length?'cursor: move;':'cursor:not-allowed'">
                                <div class="yitiao mt5 mb5">
                                  <div class="yitiao-icon">调</div>
                                  <el-link class="yitiao-but" :underline="false" type="danger" @click="qingChu(rqIndex, index, xqIndex, xqItem.kcs)">删</el-link>
                                </div>
                                  <div>
                                    <p>{{ kcItem.bjmc }}</p>
                                    <p>{{ kcItem.kcmc }}</p>
                                    <p>{{ kcItem.jsxms }}</p>
                                    <p>{{ kcItem.jxcdmcs }}</p>
                                  </div>
                              </div>
                            </template>
                            <p style="text-align: center;">详情</p>
                            <div>与 【
                              <p>周次：{{ kcItem.tkzc}}</p>
                              <p>星期：{{ kcItem.tkxq }}</p>
                              <p>节次：{{ kcItem.tkjc }}</p>
                              <p>课程：{{ kcItem.tkkcmc }}</p>
                              <p>教师：{{ kcItem.tkjsxms }}</p>
                              <p>场地：{{ kcItem.tkjxcds }}</p>
                              】 调换
                            </div>
                          </el-popover>
                          <!-- [tkbz]调课标志: 0-正常，1-已调课 -->
                          <div v-else>
                            <div>
                              <div>
                                <p>{{ kcItem.bjmc }}</p>
                                <p>{{ kcItem.kcmc }}</p>
                                <p>{{ kcItem.jsxms }}</p>
                                <p>{{ kcItem.jxcdmcs }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </el-main>
          </el-container>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openTiaoKe', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import { closeWindow, actionPost } from '@/api/common.js'
import { warningPrompt, successPrompt } from '@/utils/promptInfo.js'

const props = defineProps({
  openTiaoKe: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openTiaoKe', 'ReturnData'])

const kblx = ref(1) // 课表类型

const rqTableData = ref([]) // 表头日期
const tableData = ref([]) // 列表

const jiaZai = ref(false) // 加载

const thData = ref({}) // 调换

// 教师课表日期
const jskbrqData = ref([])
const initJiaoShiKeBiaoRiQi = () => {
  kblx.value = 1
  const o = {
    url: '/api/v2/jiaowu/tiaokejilu/jiaoshikebiaoriqi',
    data: { dbgzid: row.value.dbgzid }
  }
  jiaZai.value = true
  actionPost(o).then((res) => {
    jiaZai.value = false
    if (res.code === 200) {
      if (res.data.length === 0) {
        res.data = [
          { zc: null, listRiQi: ['', '', '', '', '', '', ''] },
          { zc: null, listRiQi: ['', '', '', '', '', '', ''] }
        ]
      }
      if (res.data.length === 1) {
        res.data.push({ zc: null, listRiQi: ['', '', '', '', '', '', ''] })
      }
      jskbrqData.value = res.data
      rqTableData.value = jskbrqData.value
      initJiaoShiKeBiaoList()
    } else {
      warningPrompt(res.message)
    }
  })
}
const row = ref()
// 教师课表
const jiaoShiData = ref([])
const initJiaoShiKeBiaoList = () => {
  kblx.value = 1
  if (
    thData.value.btjc === null &&
    thData.value.btrq === null &&
    thData.value.btxq === null &&
    thData.value.btzc === null
  ) {
    thData.value = {}
  }
  const o = {
    url: '/api/v2/jiaowu/tiaokejilu/jiaoshikebiao',
    data: { dbgzid: row.value.dbgzid }
  }
  jiaZai.value = true
  actionPost(o).then((res) => {
    jiaZai.value = false
    if (res.code === 200) {
      res.data.forEach((element) => {
        element.forEach((val) => {
          val.xqs = [
            { zc: val.zc, xq: 1, jc: val.jc, kcs: [], isJskb: true },
            { zc: val.zc, xq: 2, jc: val.jc, kcs: [], isJskb: true },
            { zc: val.zc, xq: 3, jc: val.jc, kcs: [], isJskb: true },
            { zc: val.zc, xq: 4, jc: val.jc, kcs: [], isJskb: true },
            { zc: val.zc, xq: 5, jc: val.jc, kcs: [], isJskb: true },
            { zc: val.zc, xq: 6, jc: val.jc, kcs: [], isJskb: true },
            { zc: val.zc, xq: 7, jc: val.jc, kcs: [], isJskb: true }
          ]
          if (val.kcs.length) {
            val.kcs.forEach((item) => {
              val.xqs.forEach((kcItem) => {
                if (item.xq === kcItem.xq) {
                  kcItem.kcs.push(item)
                }
              })
            })
          }
        })
      })
      res.data.forEach((element) => {
        element.map((item) => {
          delete item.kcs
          return item
        })
      })
      jiaoShiData.value = res.data
      tableData.value = jiaoShiData.value
      
    } else {
      warningPrompt(res.message)
    }
  })
}
// 班级课表日期
const bjkbrqData = ref([])
const initBanJiKeBiaoRiQiList = () => {
  kblx.value = 2
  const o = {
    url: '/api/v2/jiaowu/tiaokejilu/banjikebiaoriqi',
    data: {
      dbgzid: row.value.dbgzid,
      bjid: thData.value.kc[0].bjid,
      zc: thData.value.zc
    }
  }
  jiaZai.value = true
  actionPost(o).then((res) => {
    jiaZai.value = false
    if (res.code === 200) {
      rqTableData.value = []
      bjkbrqData.value = res.data
      rqTableData.value = bjkbrqData.value
      initBanJiKeBiaoList()
    } else {
      warningPrompt(res.message)
      initJiaoShiKeBiaoRiQi()
    }
  })
}
// 班级课表
const banJiData = ref([])
const initBanJiKeBiaoList = () => {
  kblx.value = 2
  const o = {
    url: '/api/v2/jiaowu/tiaokejilu/banjikebiao',
    data: {
      dbgzid: row.value.dbgzid,
      bjid: thData.value.kc[0].bjid,
      zc: thData.value.zc
    }
  }
  jiaZai.value = true
  actionPost(o).then((res) => {
    jiaZai.value = false
    if (res.code === 200) {
      tableData.value = []
      banJiData.value = res.data
      shiFouKePai()
    } else {
      warningPrompt(res.message)
      initJiaoShiKeBiaoRiQi()
    }
  })
}

// 验证班级课表是否可排
const shiFouKePai = () => {
  const o = {
    url: '/api/v2/jiaowu/tiaokejilu/tuodongyanzhengbanjikebiaokepai',
    data: {
      dbgzid: row.value.dbgzid,
      bjid: thData.value.kc[0].bjid,
      xljskbid: thData.value.kc[0].id,
      xq: thData.value.xq,
      zc: thData.value.zc,
      jc: thData.value.jc
    }
  }
  jiaZai.value = true
  actionPost(o).then((res) => {
    jiaZai.value = false
    if (res.code === 200) {
      banJiData.value.forEach((tabItem, tabIndex) => {
        tabItem.forEach((element) => {
          element.xqs.forEach((xqsItem) => {
            xqsItem.isJskb = false
            res.data[tabIndex].forEach((resItem) => {
              if (
                xqsItem.zc === resItem.zc &&
                xqsItem.xq === resItem.xq &&
                xqsItem.jc === resItem.jc
              ) {
                xqsItem.sfkt = resItem.sfkt
              }
            })
          })
        })
      })
      tableData.value = banJiData.value
    } else {
      warningPrompt(res.message)
    }
  })
}
// 调换
const tiaoKe = (item) => {
  bjkbrqData.value.forEach((element) => {
    if (element.zc === item.zc) {
      item.rq = element.listRiQi[item.xq - 1]
    }
  })
  const data = thData.value
  delete data.kc
  data.btjc = item.jc
  data.btrq = item.rq
  data.btxq = item.xq
  data.btzc = item.zc
  const o = { url: '/api/v2/jiaowu/tiaokejilu/tiaoke', data: data }
  jiaZai.value = true
  actionPost(o).then((res) => {
    jiaZai.value = false
    if (res.code === 200) {
      thData.value.btjc = item.jc
      thData.value.btrq = item.rq
      thData.value.btxq = item.xq
      thData.value.btzc = item.zc
      thData.value.btkc = item.kcs
      initJiaoShiKeBiaoList()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 移除
const qingChu = (rqIndex, index, xqIndex, kcs) => {
  const o = {
    url: '/api/v2/jiaowu/tiaokejilu/shanchutiaoke',
    data: { dbgzid: row.value.dbgzid, xljskbid: kcs[0].id }
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      // tableData.value[rqIndex].forEach((element, ind) => {
      //   if (index === ind) {
      //     delete element.xqs[xqIndex].tkbz
      //     delete element.xqs[xqIndex].btkc
      //   }
      // })
      initJiaoShiKeBiaoList()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 保存调课
const submit = async () => {
  const o = {
    url: '/api/v2/jiaowu/tiaokejilu/baocuntiaoke',
    data: { dbid: row.value.id, dbgzid: row.value.dbgzid }
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      closeWindow('openTiaoKe', emits, true)
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
const initKeCheng = () => {
  const o = {
    url: '/api/v2/jiaowu/tiaokejilu/huancunshuju',
    data: { dbgzid: row.value.dbgzid }
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      // successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
watch(
  () => props.openTiaoKe,
  () => {
    if (props.openTiaoKe) {
      row.value = props.row
      initKeCheng()
      initJiaoShiKeBiaoRiQi()
    }
  },
  { deep: true, immediate: true }
)
// 拖拽开始
const tuoZhuaiKaiShi = ($event, val) => {
  
  jskbrqData.value.forEach((element) => {
    if (element.zc === val.zc) {
      val.rq = element.listRiQi[val.xq - 1]
    }
  })
  thData.value = {
    dbgzid: row.value.dbgzid,
    xljskbid: val.kcs[0].id,
    jc: val.jc,
    rq: val.rq,
    xq: val.xq,
    zc: val.zc,
    kc: val.kcs,
    btjc: null,
    btrq: null,
    btxq: null,
    btzc: null,
    btkc: null
  }
  initBanJiKeBiaoRiQiList()
}
// 拖拽中
const tuoZhuaiZhong = ($event) => {
  $event.preventDefault()
}
// 放下
const fangXia = ($event, item) => {
  
  tableData.value = []
  tiaoKe(item)
  initJiaoShiKeBiaoList()
  $event.preventDefault()
}
const up = () => {
  kblx.value = 1
  initBanJiKeBiaoRiQiList()
}
</script>

<style lang="less" scoped>
.tiaoke_ul {
  height: calc(100% - 50px);
  .tiaoke_li {
    height: 100%;
    overflow: auto;
    width: -webkit-fill-available;
    table[border]:not([border='0']):not([style*='border-color']) th,
    table[border]:not([border='0']):not([style*='border-color']) td {
      border-color: #ebeef5;
    }
    table:not([cellpadding]) th,
    table:not([cellpadding]) td {
      padding: 5px;
    }
    table {
      height: 100%;
      thead {
        height: 40px;
      }
      tbody {
        height: calc(100% - 40px);
        overflow: auto;
        border: 1px solid !important;
        .neirong {
          width: 100%;
          height: 100%;
          min-width: 100px;
          min-height: 100px;
          padding: 5px;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
        }
        .yitiao {
          width: 50%;
          display: flex;
          justify-content: space-between;
          .yitiao-icon {
            width: 25px;
            height: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            border: 1px solid #ccc;
            border-radius: 50%;
          }
        }
      }
    }
    th {
      background-color: #e6f7ff;
      color: rgba(0, 0, 0, 0.88);
      height: 60px;
    }
    td {
      padding: 0 !important;
    }
    .ketiao {
      cursor: move;
      color: #fff;
      background-color: #67c23a;
    }
    .buketiao {
      cursor: not-allowed;
      color: #fff;
      background-color: #f56c6c;
    }
  }
}
</style>
